import { Link } from "react-router-dom"
import News2 from "../images/news2.jpg"
import { useEffect, useState } from "react"
import SEO from './SEO';
const Blogs = () => {

const [blogs, setBlogs] = useState([])
const [loading, setLoading] = useState(true)

const [posts, setPosts] = useState([])

useEffect(() => {
  const fetchBlogs = async () => {
    try {
      const res = await fetch(
        "https://mamshospitals.mamscollege.com/wp-json/wp/v2/mams_blogs?_embed"
      )
      const data = await res.json()

      console.log(data) // 🔥 check here

      setPosts(data)
    } catch (err) {
      console.error(err)
    }
  }

  fetchBlogs()
}, [])

  const categories = ["All", "Hospital News", "Health Tips", "Awards", "Research"]
  const schema = [
  {
    "@context": "https://schema.org",
    "@type": "Blog",
    "name": "MAMS Hospitals Blogs",
    "url": "https://mamshospitals.com/blogs",
    "description": "Read the latest healthcare blogs, medical tips, treatment guides, wellness advice, and hospital updates from MAMS Hospitals Hyderabad.",
    "publisher": {
      "@type": "Organization",
      "name": "MAMS Hospitals",
      "logo": {
        "@type": "ImageObject",
        "url": "https://mamshospitals.com/MAMS-Logo.png"
      }
    },

    "sameAs": [
      "https://www.facebook.com/MAMSHospitals",
      "https://www.instagram.com/mams_hospitals"
    ]
  },

  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Healthcare Blogs & Medical Articles - MAMS Hospitals",
    "url": "https://mamshospitals.com/blogs",
    "description": "Explore expert healthcare blogs, wellness articles, treatment information, medical advancements, and hospital updates from MAMS Hospitals Hyderabad.",
    "keywords": [
      "Healthcare Blogs Hyderabad",
      "Medical Articles Hyderabad",
      "Hospital Blogs Hyderabad",
      "Health Tips Hyderabad",
      "Wellness Articles Hyderabad",
      "Medical News Hyderabad",
      "MAMS Hospitals Blogs"
    ]
  },

  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "What type of blogs are available on MAMS Hospitals?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "MAMS Hospitals publishes healthcare blogs, wellness tips, disease awareness articles, treatment guides, medical advancements, and hospital updates."
        }
      },
      {
        "@type": "Question",
        "name": "Are the blogs written by medical experts?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, MAMS Hospitals blogs are created and reviewed by experienced healthcare professionals and medical experts."
        }
      },
      {
        "@type": "Question",
        "name": "How often are blogs updated?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "MAMS Hospitals regularly updates its blog section with new healthcare articles, medical tips, and wellness information."
        }
      }
    ]
  }
];
  return (
    <>
  <SEO
    title="Healthcare Blogs & Medical Articles in Hyderabad | MAMS Hospitals"
    description="Read expert healthcare blogs, wellness tips, treatment guides, disease awareness articles, and medical updates from MAMS Hospitals Hyderabad."
    keywords="healthcare blogs Hyderabad,
medical articles Hyderabad,
hospital blogs Hyderabad,
health tips Hyderabad,
wellness articles Hyderabad,
medical news Hyderabad,
disease awareness blogs Hyderabad,
doctor advice Hyderabad,
treatment guides Hyderabad,
healthcare updates Hyderabad,
MAMS Hospitals blogs"
    schema={schema}
    canonicalUrl="https://mamshospitals.com/blog"
  />
    <div className="flex flex-col min-h-screen">
      {/* Hero Section */}
      <section className="bg-primary/5 py-12 md:py-20">
        <div className="container mx-auto px-4 max-w-6xl">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-3xl md:text-5xl font-semibold text-gray-800 mb-6">Blogs</h1>
            <p className="text-lg text-gray-600">
              Stay updated with the latest Blogs and medical advancements from MAMS Hospitals.
            </p>
          </div>
        </div>
      </section>

      {/* Blog Content */}
      <section className="py-16 px-4">
        <div className="container mx-auto max-w-6xl">
          <div className="flex flex-col md:flex-row gap-8">
            {/* Main Content */}
            <div className="md:w-4/4">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  {posts.length === 0 ? (
                    <p>Loading Blogs</p>
                  ) : (
                    posts.map((post) => {
                      const image =
                        post._embedded?.["wp:featuredmedia"]?.[0]?.source_url

                      return (
                       <div
                          key={post.id}
                          className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-all duration-300"
                        >
                          {/* Image First */}
                          <img
                            src={image}
                            alt={post.title.rendered}
                            className="w-full h-56 object-cover"
                          />

                          {/* Content */}
                          <div className="p-5">
                            {/* Heading */}
                            <h2 className="text-2xl font-bold text-gray-900 mb-3 line-clamp-2">
                              {post.title.rendered}
                            </h2>

                            {/* Description */}
                            <div
                            className="text-gray-700 text-sm leading-7 line-clamp-3"
                              dangerouslySetInnerHTML={{
                                __html: post.excerpt.rendered,
                              }}
                            />

                            {/* Link */}
                           <Link
                              to={`/blog/${post.slug}`}
                              className="inline-block mt-4 text-[#096256] font-semibold hover:text-[#074a42]"
                            >
                              Read More →
                            </Link>
                          </div>
                        </div>
                      )
                    })
                  )}
                </div>
            </div>

          </div>

          <div className="mt-12 text-center">
            <Link to="/">
              <div className="inline-flex items-center text-[#096256] font-medium">
                <svg className="mr-2 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                </svg>
                Back to Home
              </div>
            </Link>
          </div>
        </div>
      </section>
    </div>
    </>
  )
}

export default Blogs
